<template>
  <loading-state
    v-if="loading"
    :loading="loading"
  />
  <div
    v-else
  >
    <v-list
      v-if="zones && zones.length"
      two-line
      subheader
    >
      <div
        v-for="(zone, index) in zones"
        :key="zone.id"
      >
        <v-list-tile @click="$emit('edit-zone', zone)">
          <v-list-tile-content>
            <v-list-tile-title>{{ zone.label }}</v-list-tile-title>
            <v-list-tile-sub-title>
              {{ $t('Zones:') }} {{ zone.territories.length }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <span
              color="primary--text"
              class="text-uppercase"
            >
              {{ zone.code }}
            </span>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider
          v-if="index !== zones.length-1"
        />
      </div>
    </v-list>
    <v-flex
      v-else
    >
      {{ $t('No zones to display, create some!') }}
    </v-flex>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'

export default {
  name: 'LocalisationZoneList',

  components: {
    LoadingState
  },

  props: {
    zones: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>
